import React, { useContext } from 'react';
import ListOption from '../components/ListOption';
import { PlaceListContext } from '../context/PlaceListProvider';

const ListOptionContainer = () => {
  return <ListOption />;
};

export default ListOptionContainer;
